export const subscriptionItems = Object.freeze({
    'TRACKERS': 'cgv_tracker_device_unit',
    'BLOCKERS': 'cgv_tracker_feature_fuel_lock_unit',
    'PLUGANDPLAY': 'cgv_tracker_device_plug_and_play_unit',

    'CONTELE_SYSTEM': 'cgv_contele_system_unit',
    
    'BLOCKERS_12_VOLTS': 'cgv_tracker_feature_fuel_lock_12_unit',
    'BLOCKERS_24_VOLTS': 'cgv_tracker_feature_fuel_lock_24_unit',

    'TRACKERS_2G': 'cgv_tracker_device_2G_unit',
    'TRACKERS_4G': 'cgv_tracker_device_4G_unit',
    
    'CAMERA': 'cgv_tracker_camera_unit',
    'CAMERA_IA': 'cgv_tracker_camera_ia_unit',
    'CAMERA_SETUP': 'cgv_cam_initial_setup_unit',
    'FINE_MANAGER': 'cgv_tracker_fine_manager_unit'
});

export const productIdMatcher = {
    isPlugAndPlay: (id) => id.includes('cgv_tracker_device_plug_and_play_unit'),
    isConteleSystem: (id) => id.includes('cgv_contele_system_unit'),
    isTracker2G: (id) => id.includes('cgv_tracker_device_2G_unit'),
    isTracker4G: (id) => id.includes('cgv_tracker_device_4G_unit'),
    isFuelLock12V: (id) => id.includes('cgv_tracker_feature_fuel_lock_12_unit'),
    isFuelLock24V: (id) => id.includes('cgv_tracker_feature_fuel_lock_24_unit'),
    isCamera: (id) => id.includes('cgv_tracker_camera_unit') && !id.includes('_ia_'),
    isCameraIA: (id) => id.includes('cgv_tracker_camera_ia_unit'),
    isFineManager: (id) => id.includes('cgv_tracker_fine_manager_unit')
};